import React,{ useState} from 'react';
import { useSelector,  connect} from 'react-redux';
import { Divider, Loader } from 'rsuite';
import * as actionsUser  from '../../../../app/actions/user';
import {isNoCyrilicFound, getLatin} from '../../../../app/common/services/vehicle.service';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';
import { CheckBoxCustom } from '../elements/inputFields';
import { NuInsInputTextLabel, NuInsInputNumLabel } from '../elements/inputFieldsLabel';


const UserDetails = ({onBack, onForward, updateUserDetails, style}) => {

    const {ownerType}  = useSelector(state => state.questionsPolicy);

    const ownerDetails = useSelector(state => state.ownerDetails);

    const userDetails = useSelector(state => state.userDetails);

    const [sameAsOwner, setSameAsOwner] = useState(false);

    const [checkFields, setCheckFields] = useState({});

    const [loading, setLoading] = useState(false);

    const inputFields = ['firstNameCyrillic', 'middleNameCyrillic', 'lastNameCyrillic', 'userPubId'];
    const errorMsg    = "Полето е задължително";

    const handleSameAsOwner = (data) => {
        if(data) updateUserDetails({...ownerDetails, userPubId: ownerDetails?.personPublicId }); 
        setSameAsOwner(data);
    }

    const onChangeHandler = (field, data) =>  {
        if(field.includes('Cyrillic')) {
            const latinField = field.substring(0, field.length-8);
            updateUserDetails({[field]: data, [latinField]: getLatin(data)});
        } else {
    
            updateUserDetails({[field]: data});
        }
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const checkForError = (field, type, allFields) =>  {
        switch (type) {
            case 'cyrilic':
                const nonCyrFound = userDetails[field] ? isNoCyrilicFound(userDetails[field]) : false;
                return (checkFields[field] || allFields) && (nonCyrFound || !userDetails[field]);
            case 'id':
                return (checkFields[field] || allFields) && (!userDetails[field] || (userDetails[field]?.length < 10));
            default:
                return (checkFields[field] || allFields) && !userDetails[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'cyrilic':
                return `${errorMsg} ${userDetails[field] ? 'на кирилица' : ''}`;
            case 'id':
                return `${errorMsg} ${userDetails[field] ? '10 символа' : ''}`;
            default:
                return errorMsg;
        }
    }

    const valdateAllFields = () => {

        for(let field of inputFields) {
            if(field.includes('Cyr')) {
                if(checkForError(field, 'cyrilic', true)) return false;
            } else if (field === 'userPubId') {
                if(checkForError(field, 'id', true)) return false;
            } else {
                if(checkForError(field, null, true)) return false;
            }
        }

        return true;
    }

    const goBack = () => {
        onBack(10)
    }

    const goForward = () => {
        onForward(12);
    }

    const submitHandler = () => {
        setCheckFields(inputFields.reduce((acc, field) => ({...acc, [field]: true}) , {}));

        if(valdateAllFields()) {
            goForward();
        }
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={4} steps={4} labels={steppLabels}/>
            </div>
            <Divider />
            {loading 
            ? <Loader backdrop center size="lg" speed="slow" /> 
            : <>
                <h6 style={{paddingLeft:"2rem", fontWeight: '500', marginBottom: '20px'}}>Моите данни</h6>
               
                {ownerType !== '1' && 
                    <div className="steps_container-checkbox">
                        <CheckBoxCustom onChange={(data)=>handleSameAsOwner(data)} value={sameAsOwner} />
                        <div>Аз съм собственик на застрахованото МПС </div>
                    </div>
                }
             
                <NuInsInputTextLabel onChange={(data)=>onChangeHandler('firstNameCyrillic', data)} onBlur={()=>onBlurHandler('firstNameCyrillic')} 
                    placeholder={"Име"} 
                    value={userDetails['firstNameCyrillic']} 
                    error={checkForError('firstNameCyrillic', 'cyrilic')} 
                    errorMsg={generateErrorMsg('firstNameCyrillic', 'cyrilic')}
                    styles={{marginBottom: '20px', marginTop: '20px'}}/>
         
                <NuInsInputTextLabel onChange={(data)=>onChangeHandler('middleNameCyrillic', data)} onBlur={()=>onBlurHandler('middleNameCyrillic')} 
                    placeholder={"Презиме"} 
                    value={userDetails['middleNameCyrillic']} 
                    error={checkForError('middleNameCyrillic', 'cyrilic')} 
                    errorMsg={generateErrorMsg('middleNameCyrillic', 'cyrilic')}
                    styles={{marginBottom: '20px'}}/>
           
                <NuInsInputTextLabel onChange={(data)=>onChangeHandler('lastNameCyrillic', data)} onBlur={()=>onBlurHandler('lastNameCyrillic')} 
                    placeholder={"Фамилия"} 
                    value={userDetails['lastNameCyrillic']} 
                    error={checkForError('lastNameCyrillic', 'cyrilic')} 
                    errorMsg={generateErrorMsg('lastNameCyrillic', 'cyrilic')}
                    styles={{marginBottom: '20px'}}/>

                <NuInsInputNumLabel onChange={(data)=>onChangeHandler('userPubId', data)} onBlur={()=>onBlurHandler('userPubId')} slice={10} 
                    placeholder={"ЕГН"} 
                    value={userDetails['userPubId']} 
                    error={checkForError('userPubId', 'id')} 
                    errorMsg={generateErrorMsg('userPubId', 'id')}
                    styles={{marginBottom: '30px'}}/>

                <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={submitHandler}>Продължи</button>             
            </>
            }
        </div>
    )
}

export default connect(null, {...actionsUser})(UserDetails);